import { Container } from 'inversify';

var DIContainer = new Container();
export default DIContainer;
